import {WorkbasketTableDto} from "../../../dto/admin/WorkbasketTableDto";
import {Button, Col, message, Modal, Radio, Row, Space, Spin} from "antd";
import adminService from "../../../service/adminService";
import {useEffect, useState} from "react";
import {CustomerVerificationWrapperDto} from "../../../dto/CustomerVerificationWrapperDto";
import {CustomerVerificationTimeSlotsDto} from "../../../dto/CustomerVerificationTimeSlotsDto";
import {CustomerVerificationScheduleDto} from "../../../dto/CustomerVerificationScheduleDto";
import {getUserInfo} from "../../../security/KeyclockConfig";
import {
    BASKET_STATUS_SIGNATURE_BASKET,
    DOC_CODE_SIGNATURE_DOC_TEMP,
    IDENTITY_DOC_TYPE_CODE_LIST
} from "../../../util/Constants";
import documentService from "../../../service/documentService";
import ErrorHandler from "../../../util/ErrorHandler";
import jobApiService from "../../../service/jobApiService";
import twilioApiService from "../../../service/twilioApiService";


interface propType {
    record: WorkbasketTableDto
    isModalOpen: boolean
    onCancel: () => void
    updateTable: () => void
}

const RescheduleVideo = (props: propType) => {

    const [dateSchedules, setDateSchedules] = useState<CustomerVerificationWrapperDto>();
    const [timeSchedules, setTimeSchedules] = useState<CustomerVerificationWrapperDto>();
    const [selectedDateSch, setSelectedDateSch] = useState('');
    const [isSpinnerLoad, setSpinnerLoad] = useState(false);

    const [selectedTimeSlot, setSelectedTimeSlot] = useState<CustomerVerificationTimeSlotsDto>({
        slotStart: '',
        slotEnd: '',
        taken: false,
        slotId: 0
    });
    const [userName, setUserName] = useState('');

    useEffect(() => {
        getUserInfo().then((res: any) => {
            setUserName(res.preferred_username)
        });
        getVideoVerificationScheduleDates();

        if (props.record.basketStatus === BASKET_STATUS_SIGNATURE_BASKET) {
            getUploadedDocList()
        }
    }, [props.record.callId])
    const [documentListUploaded, setDocumentListUploaded] = useState<Array<any>>([]);

    const getUploadedDocList = () => {
        documentService.getUploadDocumentListByType(props.record.customerId, [DOC_CODE_SIGNATURE_DOC_TEMP]).then(res => {
            if (res.data.status == 'SUCCESS') {

                setDocumentListUploaded(res.data.results);
                console.log('>>>>>>', res.data.results);
            }
        }, (reason) => {
            ErrorHandler.handleError(reason);
        });
    }

    const getVideoVerificationScheduleDates = () => {
        adminService.getVideoVerificationScheduleDates().then((value) => {
            setDateSchedules(value.data.results.customerVerificationWrapperDto)
            getTimeSlots(value.data.results.customerVerificationWrapperDto.verificationScheduleDtoList[0].actualDate)
            setSelectedDateSch(value.data.results.customerVerificationWrapperDto.verificationScheduleDtoList[0].actualDate)
        }).catch(reason => {
            if (reason.response?.data?.errors.length) {
                message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
            } else {
                message.error("Schedule fetching failed").then();
            }
        });

    }
    const getTimeSlots = (selectedDate: string) => {
        setSpinnerLoad(true)
        setSelectedDateSch(selectedDate)
        adminService.getVideoVerificationScheduleSlots(selectedDate).then(res => {
            setSpinnerLoad(false)
            if (res.data !== null) {
                setTimeSchedules(res.data.results.customerVerificationWrapperDto)
            } else {
                message.error("Time slots fetching failed").then();
            }
        }).catch(reason => {
            setSpinnerLoad(false)
            if (reason.response?.data?.errors.length) {
                message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then();
            } else {
                message.error("Time slots fetching failed").then();
            }
        })
    }
    const submitData = () => {
        setSpinnerLoad(true)
        if (selectedTimeSlot.slotStart == "") {
            message.warning("Please select a time slot!")
            setSpinnerLoad(false)
        } else {
            let customerVerificationDto: CustomerVerificationScheduleDto = {
                requestedDate: selectedDateSch,
                requestedStartTime: selectedTimeSlot.slotStart,
                requestedEndTime: selectedTimeSlot.slotEnd,
                videoSlotId: selectedTimeSlot.slotId,
                signatureDocId: props.record.basketStatus === BASKET_STATUS_SIGNATURE_BASKET ?
                    documentListUploaded[0].uploadDocumentDetailDto.uploadDocumentDetailId : null
            }

            let adminReqDto = {
                workId: props.record.workId,
                username: userName,
                customerVerificationScheduleDto: customerVerificationDto
            }

            adminService.rescheduleVideoVerification(adminReqDto).then(() => {
                message.success("Schedule submitted successfully");
                props.onCancel()
                props.updateTable()
                getVideoVerificationScheduleDates();
                resetSelectedTimeSlot()
                setSpinnerLoad(false)

            }).catch(reason => {
                setSpinnerLoad(false)
                if (reason.response?.data?.errors?.length) {
                    message.error(reason.response.data.errors[reason.response.data.errors.length - 1].errorMessage).then(props.onCancel);
                } else {
                    message.error("Submit failed").then(props.onCancel);
                }
            })
        }
    }
    const resetSelectedTimeSlot = () => {
        setSelectedTimeSlot({
            slotStart: '',
            slotEnd: '',
            taken: false,
            slotId: 0
        })
        setSelectedDateSch(dateSchedules?.verificationScheduleDtoList[0] !== undefined ?
            dateSchedules.verificationScheduleDtoList[0].actualDateString : '')
    }
    const handleCancel = () => {
        props.onCancel()
        resetSelectedTimeSlot()
        // setSelectedDateSch('')
    };
    return (

        <Modal maskClosable={false} width={'40%'}
               title="Reschedule Video Verification"
               open={props.isModalOpen}
               onCancel={handleCancel}
               centered
               className='reschedule-vv-modal'
               footer={null}>
            <Spin spinning={isSpinnerLoad}>
                <Row style={{marginTop: 20}}>
                    <Col lg={24} sm={24} md={24} xl={24} className='text-input-col'>

                        <Row gutter={16}>

                            {dateSchedules?.verificationScheduleDtoList.map((value, index) => {
                                    return <Col lg={8} sm={8} md={8} xs={8} className='dates-col' key={index}>
                                        <Button type="primary"
                                                key={index}
                                                className={selectedDateSch == value.actualDateString ? "btn-select-color" : "btn-unselect-color"}
                                                onClick={() => {
                                                    resetSelectedTimeSlot()
                                                    getTimeSlots(value.actualDate)
                                                }}
                                                style={{height: '100%', width: '100%', padding: 0}}>
                                            <div style={{width: '100%', textAlign: 'center', lineHeight: '4px'}}>
                                                <h4>{value.displayMonth}</h4>
                                                <h1>{value.displayDate}</h1>
                                                <h4>{value.displayYear}</h4>
                                            </div>
                                        </Button>
                                    </Col>
                                }
                            )}
                        </Row>

                        <Row className='time-pick-area'>
                            <Col xs={24} sm={24} md={24} lg={24} xl={24} className='times-col'>
                                <Radio.Group buttonStyle="solid" size="large"
                                             key={selectedDateSch + " " + selectedTimeSlot.slotId}
                                             value={timeSchedules ? timeSchedules.verificationTimeSlotsDtoList.indexOf(selectedTimeSlot) : undefined}>

                                    {
                                        timeSchedules?.verificationTimeSlotsDtoList.map((data, index) => {
                                            return <Radio.Button disabled={data.taken}
                                                                 onClick={() => setSelectedTimeSlot(data)}
                                                                 value={index}
                                            >
                                                {data.slotStart} - {data.slotEnd}</Radio.Button>
                                        })
                                    }

                                </Radio.Group>
                            </Col>

                        </Row>
                        <Space style={{float: 'right', marginTop: 20}}>
                            <Button style={{margin: '0 8px'}} onClick={() => {
                                resetSelectedTimeSlot()
                                props.onCancel();
                            }}>
                                Cancel
                            </Button>
                            <Button style={{background: '#FF7400', width: 100}} onClick={submitData}
                                    htmlType="submit" type="primary">
                                Submit
                            </Button>
                        </Space>
                    </Col>
                </Row>
            </Spin>
        </Modal>


    )
}
export default RescheduleVideo;